import React, { useRef } from 'react';
import './index.less';
import Icon9 from '@/assets/2025/900Icon.png';
import Icon10 from '@/assets/2025/1000Icon.png';
import Icon14 from '@/assets/2025/1400Icon.png';
import Icon16 from '@/assets/2025/1600Icon.png';
// import wPeople1 from './../../../../../assets/2025/wPeople1.png';
// import wPeople2 from './../../../../../assets/2025/wPeople2.png';
interface ItrainingAnimationItem {
  icon?: string;
  title: string;
  content: any[];
}
interface TextToIcon {
  [key: string]: string;
}
const textToIcon: TextToIcon = {
  Icon9,
  Icon10,
  Icon14,
  Icon16,
};
const getImg = (img: string) => textToIcon[img];

interface ItrainingAnimationProps {
  items: ItrainingAnimationItem[];
  style?: React.CSSProperties;
  title?: string | null;
  onCompleted?: () => void;
}

const TrainingAnimation: React.FunctionComponent<ItrainingAnimationProps> = ({
  title,
  items,
  style,
  onCompleted,
}) => {
  const [play, setPlay] = React.useState(1);
  const timeoutRef = useRef<any>(null);
  const isMountedRef = useRef(true);

  const startPlay = (next = 1) => {
    if (!isMountedRef.current) {
      return;
    }

    setPlay(next);
    next += 1;
    if (next <= items.length) {
      timeoutRef.current = setTimeout(() => {
        if (isMountedRef.current) {
          startPlay(next);
        }
      }, 1200);
    } else {
      if (isMountedRef.current) {
        onCompleted && onCompleted();
      }
    }
  };

  React.useEffect(() => {
    isMountedRef.current = true;
    startPlay();
    return () => {
      isMountedRef.current = false;
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    };
  }, []);
  return (
    <div className="training-animation" style={style}>
      {/*<img className="wPeople1" src={wPeople1} alt="" />*/}
      {/*<img className="wPeople2" src={wPeople2} alt="" />*/}
      <div className="training-animation-list">
        {items?.map((itm: ItrainingAnimationItem, idx: number) => (
          <div
            key={idx}
            className={`training-animation-item  animation ${
              play >= idx + 1 ? 'fade-in' : ''
            }`}
          >
            <div className="training-animation-icon">
              {itm.icon && <img src={getImg(itm.icon)} alt="" />}
            </div>
            <div className="training-animation-content">
              <div
                className="content-left"
                dangerouslySetInnerHTML={{ __html: itm.title }}
              />
              <ul>
                {itm?.content?.map((itms: string, idxs: number) => (
                  <li key={idxs} dangerouslySetInnerHTML={{ __html: itms }} />
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

TrainingAnimation.defaultProps = {
  style: {},
  title: null,
};

export default TrainingAnimation;
